import { connect } from "react-redux";
import * as DisplayHelper from "../../../../helpers/DisplayHelper";
import * as ListCellRenders from "../../../common/list/ListCellRenders";
import List from "../../../common/list";

export const LearningUsersSummary = ({
  data,
  sections,
  query,
  setQuery,
  loading = false,
  totalRecords = 0,
  learningName = "learning_object",
  showLearningProgramDetails = false,
  statusLabel = "status",
}) => {
  const customFields = sections.reduce((acc, section) => {
    acc = [
      ...acc,
      ...(section?.fields?.map((item) => ({
        id: item.id,
        name: item.name,
        value: item.id,
        type: item.type,
        label: item.label,
      })) || []),
    ];
    return acc;
  }, []);

  const columns = [
    {
      field: "firstName",
      header: "name",
      sortable: true,
      body: ListCellRenders.FullNameAndEmail(),
    },
    {
      field: "learningName",
      header: learningName,
    },
    {
      field: "status",
      header: statusLabel,
      body: ListCellRenders.LearningStatus("status"),
    },
    {
      field: "completionPercentage",
      header: "completionPercentage",
      body: (data) => {
        const max = parseFloat(data?.maxScore || 0);
        const raw = parseFloat(data?.rawScore || 0);
        const min = parseFloat(data?.minScore || 0);
        const percentage = ((raw - min) / (max - min)) * 100;
        return (percentage && `${percentage || 0}%`) || "-";
      },
    },
    {
      field: "completedOn",
      header: "completed_on",
      body: ListCellRenders.DateOnly("completedOn"),
      sortable: true,
    },
    {
      field: "designation",
      header: "designation",
      sortable: true,
      body: ListCellRenders.StringData("designation"),
    },
    {
      field: "department",
      header: "department",
      sortable: true,
      body: ListCellRenders.StringData("department"),
    },
    {
      field: "isActive",
      header: "user_status",
      sortable: true,
      body: ListCellRenders.Status,
    },
    ...customFields
      .filter((item) => item.type !== 5)
      .map((item) => ({
        field: item.label,
        header: item.label,
        sortable: false,
        i18n: false,
        body: (rowData) => {
          return (
            rowData?.dynamicValues?.find(
              (field) => field.customFieldId === item.id
            )?.value || "-"
          );
        },
      })),
  ];

  const handlePageChange = (pageData) => {
    if (
      query.pageSize !== pageData.rows ||
      query.pageNo !== pageData.page + 1
    ) {
      setQuery({
        ...query,
        pageNo: pageData.page + 1,
        pageSize: pageData.rows,
      });
    }
  };

  const handleOnSortChange = (sortData) => {
    setQuery({
      ...query,
      pageNo: 1,
      sortColumn: sortData.sortField,
      sortBy: sortData.sortOrder === 1 ? "asc" : "desc",
    });
  };

  if (showLearningProgramDetails) {
    columns.splice(4, 0, {
      field: "learningProgramName",
      header: "learning_program",
      sortable: true,
    });
    columns.splice(5, 0, {
      field: "learningProgramStatus",
      header: "learning_program_status",
      body: ListCellRenders.LearningStatus("learningProgramStatus"),
    });
  }

  if (statusLabel === "learning_object_status") {
    columns.splice(3, 0, {
      field: "sessionTime",
      header: "session_time_mins",
      body: (data) => {
        return (
          (data?.sessionTime &&
            DisplayHelper.convertSeconds(data?.sessionTime || 0)) ||
          "-"
        );
      },
      sortable: true,
    });
  }

  columns.splice(
    columns.findIndex((col) => col.field === "learningName") + 1,
    0,
    {
      field: "isOptional",
      header: "training_type",
      body: ListCellRenders.TrainingType,
    }
  );

  return (
    <List
      loading={loading}
      totalRecords={totalRecords}
      handlePageChange={handlePageChange}
      handleOnSortChange={handleOnSortChange}
      data={data || []}
      pageQuery={query}
      columns={columns.filter(
        (col) =>
          (learningName === "learning_object" &&
            col.field === "completionPercentage") ||
          col.field !== "completionPercentage"
      )}
      selectionMode=""
    />
  );
};

const mapStateToProps = (state) => ({
  sections: state.customFields.data,
});

export default connect(mapStateToProps)(LearningUsersSummary);
